import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useAuth } from "@/features/auth/AuthProvider";
import type { AmbassadorStatus } from "@/types/menu";

const FALLBACK: AmbassadorStatus = {
  referrals_validated: 0,
  theme_unlocked: false,
  editorial_weeks: false,
  promo_code: null,
  next_tier_at: 1,
};

export function useAmbassador(): {
  data: AmbassadorStatus;
  isLoading: boolean;
} {
  const { session, configured } = useAuth();
  const enabled = configured && Boolean(session);

  const query = useQuery<AmbassadorStatus>({
    queryKey: ["ambassador", session?.user.id],
    queryFn: () => api<AmbassadorStatus>("/api/v1/me/ambassador"),
    enabled,
    staleTime: 5 * 60_000,
  });

  return {
    data: query.data ?? FALLBACK,
    isLoading: enabled && query.isLoading,
  };
}
